import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  FormBuilder,
  FormGroup,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ClaimsService } from '../../../services/claims.service';
import { SectionsService } from '../../../services/sections.service';
import { UserService } from '../../../services/user.service';
import { BaseComponent } from '../../../shared/utils/base.component';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { BillingService } from '../../../services/billing.service';
import {
  DialogConfig,
  DialogService,
} from '../../../shared/services/dialog.service';
import { performValidation } from '../../../shared/utils/validation.util';

@Component({
  selector: 'ppl-add-domain',
  standalone: true,
  imports: [
    ButtonComponent,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    NzCardModule,
    NzInputModule,
    NzToolTipModule,
    CommonModule,
    NzDatePickerModule,
    NzToolTipModule,
    NzSelectModule,
    NzButtonModule,
    AccordionComponent,
  ],
  templateUrl: './add-domain.component.html',
  styleUrl: './add-domain.component.css',
})
export class AddDomainComponent extends BaseComponent implements OnInit {
  pageTitle = 'Add New Domain';
  mode = 'edit';
  configForm!: FormGroup;
  programName: any;
  moduleList: any;
  categoryList: any;
  orgTypeList: any = [];
  orgNameList: any = [];
  savedData: any = {};
  radioOptions: LookupValueItem[] = [];
  isNew = true;
  private dialogSvc = inject(DialogService);
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<any>;
  @Input() isDomainNew: any;
  @Output() cancel = new EventEmitter<boolean>();

  constructor(
    private fb: FormBuilder,
    private sectionsService: SectionsService,
    private router: Router,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,
    private userService: UserService,
    private billingService: BillingService
  ) {
    super();
  }

  ngOnInit(): void {
    this.configForm = this.fb.group({
      lkpDomainName: [''],
      lkpDomainDesc: [''],
    });

    const program = this.userService.getSelectedProgram();
    this.programName = program?.program_code;
    this.secData = this.sectionsService.getSectionData(
      this.programName,
      'configDomain'
    );

    this.savedData = this.claimsService.getFormData('configDomain');
    const action = !this.isDomainNew ? 'update' : 'add';
    this.pageTitle =
      action == 'update'
        ? `Details for ID: ${this.savedData?.lkpDomainId}`
        : this.pageTitle;
    this.isNew = this.isDomainNew;
    this.mode = !this.isDomainNew ? 'read' : 'edit';
  }

  onCancel() {
    this.mode = 'read';
    this.validationErrors = {};
    this.configForm.reset();
  }

  goBack() {
    this.cancel.emit(true);
  }

  onDelete() {
    this.openConfirmationPopup();
  }

  onAdd(action: string) {
    this.validationErrors = performValidation(
      this.configForm.getRawValue(),
      this.secData,
      'Next',
      undefined,
      undefined,
      this.sectionsService.getFlow(),
      this.sectionsService.getEnrollmentType()
    );
    const payload = {
      ...this.configForm.getRawValue(),
      programCode: this.programName,
      lkpDomainId: this.isDomainNew ? '0' : this.savedData?.lkpDomainId,
      isActive: this.isDomainNew ? true : this.savedData?.isActive,
    };
    if (Object.keys(this.validationErrors).length === 0) {
      this.billingService
        .addAndUpdateLookupDomain(payload, action)
        .subscribe((data: any) => {
          this.cancel.emit(true);
        });
    } else {
      return;
    }
  }

  onEdit() {
    this.mode = 'edit';
    const data = this.savedData;
    this.configForm.patchValue(data);
  }

  openConfirmationPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Ok',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.deleteAuth(),
      () => this.handleCancel()
    );
  }

  handleCancel() {}

  deleteAuth() {
    this.billingService
      .deleteDomain(this.programName, this.savedData.lkpDomainId)
      .subscribe((data: any) => {
        if (data.status === 200) {
            this.cancel.emit(true);
        }
      });
  }
}
